'use client';

import { useContext, useEffect } from 'react';
import { ProgressContext } from './context';

export const useProgress = (current: number) => {
  const ctx = useContext(ProgressContext);

  if (ctx === undefined) {
    throw new Error('useProgress() must be used inside <ProgressProvider/>');
  }

  useEffect(() => {
    ctx.setCurrent(current);
  }, []);

  return ctx;
};
